import Facebook from "./Facebook";
import SEO from "./SEO";
import Twitter from "./Twitter";

export { Facebook, Twitter };

export default SEO;
